import AirtableTable from "../AirtableTable";
import { Unit } from "../models";
import { airtableFields, airtableTables } from "../schema";

export class UnitTable extends AirtableTable<Unit> {
  	constructor(instance: any) {
		super(instance, airtableTables.units);

		this.fields = [
			airtableFields.units.unit, airtableFields.units.description, airtableFields.units.course,
			airtableFields.units.overview, airtableFields.units.downloadedBy
		]
	}

	getAll = () => {
		return this.list({
			sort: [{
			  field: airtableFields.units.unit,
			  direction: "asc"
			}]
		})
	}

	getByCourse = (course: string) => {
		return this.listAll().then((items: any[]) => items.filter((item) => item[airtableFields.units.course] === course));
	}
}
